class InternationalDeliveryPopup extends HTMLElement {
    constructor() {
      super();
  
      const showPopup_status = sessionStorage.getItem('showPopup_status');
      const currentMarket = sessionStorage.getItem('currentMarket');
      const shopify_market = Shopify.country;

      if (showPopup_status === 'false' && currentMarket == shopify_market) return;
      this.checkUserCountry().then(data => {
        const country = data.detected_values.country.handle;
        if (country !== 'AU' || shopify_market !== 'AU') {
            this.showPopup();
          }
      }).catch((error) => {
        console.error(error);
      });
    }
  
    async checkUserCountry() {
      try {
        const response = await fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const data = await response.json();
        return data;
      } catch (error) {
        console.error('An error occurred:', error);
      }
    } 
    showPopup(){
        const popupContainer = document.querySelector('international-delivery-popup');
        if (popupContainer) {
            const popupContainer_close = popupContainer.querySelector('#close');
            const popupContainer_bg = popupContainer.querySelector('.bgsize');

            popupContainer.style.display = 'block'
            document.body.style.overflow = 'hidden';

            popupContainer_close.addEventListener('click', () => {
                popupContainer.style.display = 'none';
                this.setSessionData()
            })

            popupContainer_bg.addEventListener('click', () => {
                popupContainer.style.display = 'none';
                this.setSessionData()
            })
        }
    }

    setSessionData() {
        sessionStorage.setItem('showPopup_status', 'false');
        sessionStorage.setItem('currentMarket', Shopify.country);
    }
  }
  
  if (!window.customElements.get('international-delivery-popup')) {
    customElements.define('international-delivery-popup', InternationalDeliveryPopup);
  }